import { criteriaFieldsGQLQueryFragment, criteriaAllowedTiersGQLQueryFragment, criteriaRequiredSkusGQLQueryFragment } from '~internal/utils/OfferNotificationContext';

const skuQueryFragment = `
    inCart
    formattedPrice
    skuID
    inventoryStatus
    largeImage
    shadeName
    skuBaseID
    productName
    productCode
    altProductImages
    productWhoItIsFor
    shortDescription
    path
    PRODUCT_SIZE
    productConcern
`;

export const LoyaltyBenefits = (benefitOfferType: string) => {
    const viewArr  = benefitOfferType.split(',');
    const loyaltyBenefitsQuery = `{
        user {
            benefits_no_sku (views:[${viewArr}]) {
                inCart
                offerCode
                image
                meetsCriteria
                used
                uses
                skuBased
                points
                criteria
                totalUses
                promo {
                    text {
                        title
                        subHeading
                        description
                        action
                        redeemed
                        howToUse
                    }
                    URL {
                        action
                        learnMore
                        terms
                    }
                }
                benefits
                criteriaViewValidations {
                    class
                    met
                }
                ${criteriaFieldsGQLQueryFragment}
                ${criteriaAllowedTiersGQLQueryFragment}
                ${criteriaRequiredSkusGQLQueryFragment}
                pointsNeeded
                skus {
                    choices
                    choicesPcatData {
                        skuData {
                            ${skuQueryFragment}
                        }
                    }
                }
            }
        }
    }
    `;

    return loyaltyBenefitsQuery;
};
